import React from 'react';
import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import { endPoints } from 'api/endpoints';
import axios from 'api/request';
import { useMutation } from 'react-query';
import Select from 'components/select';
import { orderPayload, certCreationRequired, customDomainFieldsDiasbled } from 'pages/provisioning/virtual-service/store';

const ADCertGroup = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(orderPayload);
    const [options, setOptions] = React.useState([]);
    const [isRequired] = useRecoilState(certCreationRequired);
    const [isDisabled] = useRecoilState(customDomainFieldsDiasbled);
    const adCertGroupApi = useMutation(() => axios.get(`${endPoints.riServices.COMMON.adCertGroup}`));

    const setADCertGroup = (adCertGroup) => {
        setOrder({
            ...order,
            adCertGroup,
        });
    };

    const resetOptions = () => {
        setOptions([]);
    };

    const isExistsInOptions = (adCertGroup) => options.find((option) => adCertGroup === option.value);

    const handleOnSelectChange = (selected) => setADCertGroup(selected.value);

    React.useEffect(() => {
        if (adCertGroupApi?.isSuccess) {
            setOptions(
                adCertGroupApi?.data?.data?.map((app) => ({
                    label: app,
                    value: app,
                }))
            );
        }
    }, [adCertGroupApi?.isSuccess]);

    React.useEffect(() => {
        if (options && options?.length === 1 && !order?.adCertGroup) {
            setOrder({ ...order, adCertGroup: options?.[0].value });
        }
        if (options && options?.length && order?.adCertGroup) {
            const adCertGroup = isExistsInOptions(order?.adCertGroup);
            setOrder({ ...order, adCertGroup: adCertGroup?.value });
        }
    }, [options]);

    React.useEffect(() => {
        resetOptions();
        adCertGroupApi.mutate();
    }, []);

    React.useEffect(() => {
        if (!order?.adCertGroup && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [order?.adCertGroup, order?.isTouched]);

    const validateInput = () => {
        let validateText = '';
        if ((isTouched && order?.isTouched && !order?.adCertGroup) || isTouched) {
            validateText = 'validate';
        } else if (isRequired && !order?.adCertGroup) {
            validateText = 'validate1';
        }
        return validateText;
    };

    return (
        <Box display="flex" gap={1}>
            <Box display="flex" alignItems="center" gap={1} sx={{ width: '100%' }}>
                <Select
                    dataTestId="ad-cert-group-auto"
                    key="adCertGroup"
                    label="Active Directory Certificate Group *"
                    value={order?.adCertGroup || null}
                    options={options}
                    handleOnSelect={(value) => handleOnSelectChange(value)}
                    disabled={!isRequired || isDisabled}
                    isLoading={adCertGroupApi.isLoading}
                    isRequired={isTouched}
                    className={validateInput()}
                />
            </Box>
        </Box>
    );
};

export default React.memo(ADCertGroup);
